import React ,{Component} from 'react'
import {connect} from 'react-redux';

//Third party dependencies
import moment from 'moment';

//Material UI Components
import Button  from "@material-ui/core/Button";
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper'
import Modal from '@material-ui/core/Modal'

//Material UI Icons
import LocationOnIcon from '@material-ui/icons/LocationOn';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';


export class ActivityPreview extends Component{
    constructor(props){
        super(props);
        
        this.state={
            //modal
            fullSizeComponent:undefined,
            //size
            baseSize: 1,
            //screenSize
            rootScreenSize:undefined,
        }
    };

    componentDidMount(){
        window.addEventListener('resize', this.getScreenSize);
        this.getScreenSize();
     };

    componentWillUnmount(){ 
        window.removeEventListener('resize', this.getScreenSize);
    }

    getScreenSize = () =>{
        const breakpoints={  
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        } 
        const innerWidth = window.innerWidth;
        const innerHeight = window.innerHeight;
        let screenSize = 'xs';

        if(innerWidth > breakpoints.xl){
            screenSize = 'xl';
        }else if (innerWidth > breakpoints.lg){
            screenSize = 'lg';
        }else if (innerWidth > breakpoints.md){
            screenSize = 'md';
        } else{
            screenSize = 'xs';
        }
        const rootScreenSize={
            innerWidth: innerWidth,
            innerHeight:innerHeight,
            screenSize: screenSize,
        }

        this.setState({rootScreenSize:rootScreenSize});
    }

    //#region Methods
    GetDateDescription = (startDate = new Date(), endDate = new Date()) =>{

        let dateDescription = '';
        const startMoment = moment(startDate);
        const endMoment = moment (endDate);

        if(startMoment && endMoment){
         const day = startMoment.format('dddd MMMM DD, hh:mm a');
         
         dateDescription = day;
        }

        return dateDescription
    };
    //#endregion

    //#region Internal Componnets
    TitleComponent = () =>{
        const styles={
            textStyles:{
                fontSize:this.state.baseSize? this.state.baseSize * 2 + 'em': '1em'
            }
        }

        return(
            <Grid item id='titleComponent' className='ActivityPreviewActivityTitle EllipsisDiv' style={{...styles.textStyles}} >
                {this.props.title? this.props.title: undefined}
            </Grid>
        )
    };

    DateComponent = () => {
        const styles={
            textStyles:{
                fontSize:this.state.baseSize? this.state.baseSize * 1.2+ 'em': '1em',
            },
            iconStyles:{
                fontSize:this.state.baseSize? this.state.baseSize * 2 + 'em': '1em',

            },
        }
        
        return(
            <Grid item container id='dateComponent' alignContent='center' justify='flex-start' style={{}}>
                <Grid item xs={2} style={{ textAlign:'left'}}>
                    <WatchLaterIcon style={{...styles.iconStyles}}/>
                </Grid>
                <Grid item xs={10} className='ActivityPreviewInfo EllipsisDiv'  style={{...styles.textStyles}} >
                    {this.GetDateDescription(this.props.startDate, this.props.endDate)}
                </Grid>
            </Grid>
        )
    };

    LocationComponent = () =>{
        const styles={
            textStyles:{
                fontSize:this.state.baseSize? this.state.baseSize * 1.2+ 'em': '1em'
            },
            iconStyles:{
                fontSize:this.state.baseSize? this.state.baseSize * 2 + 'em': '1em'
            },
        }

        return(
            <Grid item container id='locationComponent' alignItems='center'>
            {
                this.props.location? 
                    <Grid item container alignContent='center' justify='flex-start'>
                        <Grid item xs={2} style={{textAlign:'left'}}>
                            <LocationOnIcon style={{...styles.iconStyles}}/>
                        </Grid>
                        <Grid item xs={10}  className='ActivityPreviewInfo EllipsisDiv'  style={{...styles.textStyles}} >
                            {this.props.location? this.props.location : undefined}
                        </Grid>
                    </Grid>
                    : 
                    undefined
            }
            </Grid>
                
        )
    };

    TransportationComponent = () =>{
        const styles={
            textStyles:{
                fontSize:this.state.baseSize? this.state.baseSize * 1.2+ 'em': '1em'
            },
            iconStyles:{
                fontSize:this.state.baseSize? this.state.baseSize * 2 + 'em': '1em'
            },
        }

        return(
            <Grid item container id='transportation_Component'  alignContent='center' justify='flex-start'>
                <Grid item xs={2} style={{textAlign:'left'}}>
                    <AirportShuttleIcon style={{...styles.iconStyles}}/>
                </Grid>
                <Grid item xs={10}   className='ActivityPreviewInfo EllipsisDiv' style={{...styles.textStyles}} >
                    {this.props.transportation? 'Transportation is provided': 'No transportation is provided'}
                </Grid>
            </Grid>
        )
    };

    CategoryComponent = () =>{
          const styles={
            textStyles:{
                fontSize:this.state.baseSize? this.state.baseSize * 1.2+ 'em': '1em'
            },
            iconStyles:{
                width:this.state.baseSize? this.state.baseSize * 2 + 'em': '1em',
                height:this.state.baseSize? this.state.baseSize * 2 + 'em': '1em',
            },
        }
        

        return(
            <Grid item container id='category_Component' justify='flex-start'>
                <Grid item xs={2} style={{textAlign:'left'}}>
                    {
                        (this.props.category && this.props.category.iconUrl) ?
                            <img className='ActivityPreviewImageSvg' style={{...styles.iconStyles}}  alt={(this.props.category && this.props.category.name) ? this.props.category.name : undefined} src={(this.props.category && this.props.category.iconUrl) ? this.props.category.iconUrl : undefined}/>
                            :
                            undefined
                    }
                </Grid>
                <Grid item xs={10}  className='ActivityPreviewInfo EllipsisDiv' style={{...styles.textStyles}} >
                    {(this.props.category && this.props.category.name) ? this.props.category.name : undefined}
                </Grid>
            </Grid>
        )
    };

    DescriptionComponent = () =>{
        const styles={
            textStyles:{
                fontSize:this.state.baseSize? this.state.baseSize * 1.2+ 'em': '1em'
            },
            iconStyles:{
                width:this.state.baseSize? this.state.baseSize * 2 + 'em': '1em',
                height:this.state.baseSize? this.state.baseSize * 2 + 'em': '1em',
            },
        }

        return(
            <Grid item container  xs={12}  alignItems='center' justify='center' className='ActivityPreviewInfo EllipsisDiv'>
                <Grid item style={{...styles.textStyles, paddingLeft:'10px'}}>
                    {this.props.description? this.props.description: undefined}
                </Grid>
            </Grid>
        )
    };

    ClickSeeFullSizeComponent = ({component = ''}) =>{
        const newComponent = component? component: undefined;

        const styles={
            button:{
                color:'#969595',
                textTransform:'none',                
            }
        }
        return(
            <Grid item >
                <Button style={{...styles.button}} disableRipple = {true} disableFocusRipple={true}  onClick={() => this.setState({fullSizeComponent:newComponent})}>
                    Click to See Full Size
                </Button>
            </Grid>
        )
    }
    
    PreviewComponentsRow = () =>{

        return(
            <Grid item container justify='space-around' style={{padding:'20px 0px', fontSize:'6px',}}>
                <Grid item container id='thumbnailPreviewComponentContainer' xs={12}  md={3} lg={2} >
                    <Grid item xs={12} id='title_thumbnail' className='ActivityPreviewTitle'>Thumbnail Preview</Grid>
                    <this.ThumbnailPreviewComponent/>
                    <Grid item container id='ClickFullSize_thumbnail' justify='center' alignItems='center'>
                        <this.ClickSeeFullSizeComponent
                            component='thumbnail'
                        />  
                    </Grid>
                </Grid>
                <Grid item container id='detailsPageComponentContainer' xs={12}  md={4} lg={3}> 
                    <Grid item xs={12} id='title_details' className='ActivityPreviewTitle'>Detail Page Preview</Grid>
                    <this.DetailPagePreviewComponent/>
                    <Grid item container id='ClickFullSize_Details' justify='center' alignItems='center'>
                        <this.ClickSeeFullSizeComponent
                            component='detail'
                        />  
                    </Grid>
                </Grid>                
            </Grid>
        );
    }


    //#endregion

    //#region  Thumbnail preview
    ThumbnailPreviewComponent = () =>{  

        return(
            <Grid item container justify='center' >
                <Grid item container alignItems='center' justify='center' xs={12} className='ActivityPreviewInfoComponnet' style={{padding:'10px'}}>
                    <Grid item container xs={9} style={{ height:'100%'}}>
                        <this.ThumbnailInfoComponent/>
                    </Grid>
                </Grid>
            </Grid>
        )
    };
    
    ThumbnailInfoComponent = () =>{

        const backgroundImage = (this.props.themeImage && this.props.themeImage.iconUrl)? this.props.themeImage.iconUrl : ''; 
        const thumbnailIcon = (this.props.thumbnailIcon && this.props.thumbnailIcon.iconUrl)? this.props.thumbnailIcon.iconUrl : '';
        
        const styles={
            themeImage:{
                width:'100%',
                height:'100%', 
                backgroundImage:`url(${backgroundImage})`,
                backgroundPosition:'center',
                backgroundRepeat:'no-repeat',
                backgroundSize: 'contain',
            },
            thumbnailiconContainer:{
                position:'absolute',
                top:'50%', 
                left:'50%', 
                transform:'translate(-50%,-50%)'
            }
        }

        return(
            <Grid item container id='thumbnailInfoComponent_container' xs={12} justify='center' style={{height:'100%' }}>
                <Grid item container className='previewStyles'>
                    <Grid item container id='thumbnailInfoComponent_imageContainer' xs={12} justify='center' className='ActivityPreviewThumbnailImage'>
                        {
                            this.props.thumbnailImage?
                                <Grid item  xs={12} style={{width:'60%', height:'100%'}}>
                                    {
                                        this.props.thumbnailImage ? 
                                        <img style={{width:'100%', height:'100%'}} alt='icon' src={this.props.thumbnailImage}/>
                                        :
                                        undefined
                                    }
                                </Grid>
                                :

                                <Grid item container xs={12} justify='center' alignItems='center' style={{width:'100%', height:'100%', position:'relative'}}  >
                                    <img style={{width:'100%', height:'100%', }} alt='icon' src={backgroundImage} />
                                    <Grid item style={{...styles.thumbnailiconContainer}}>
                                    {
                                        thumbnailIcon?
                                            <img style={{ width:'50px', height:'50px',}} alt='icon' src={thumbnailIcon}/>
                                        :
                                        undefined
                                    }
                                    </Grid>
                                </Grid>
                        }
                    </Grid>
                    <Grid item container xs={12} className='ActivityPreviewInfoContainer' style={{backgroundColor:'#444447', height:'55%'}}>
                            <this.TitleComponent/>
                            <this.DateComponent/>
                            <this.LocationComponent/>
                            <this.CategoryComponent/>
                            <Grid item container ></Grid>
                        </Grid>
                    </Grid>                  
                </Grid>
                
            );
        };
        //#endregion   
    
    //#region  Details preview
    DetailsPreviewButtonsComponent = () =>{
        const styles={
            section:{
                textAlign:'center',
                fontSize:this.state.baseSize? this.state.baseSize + 'em': '1em',
                color:'white', 
            },
            inactiveSection:{
                opacity:'33%'
            },
            button:{
                fontSize:this.state.baseSize? this.state.baseSize + 'em': '1em',
                borderRadius:'6px',
                width:'100%',
                backgroundColor:'#009cdb',
                color:'white',
                textTransform:'none',
            }
        }
        return(
            <Grid item container xs={12} justify='space-around' style={{height:'100%'}}>
                <Grid item container style={{height:'30%'}}>
                    <Grid item xs={4} style={{...styles.section,}}>Registration</Grid>
                    <Grid item xs={4} style={{...styles.section,...styles.inactiveSection}}>Attendees</Grid>
                    <Grid item xs={4} style={{...styles.section,...styles.inactiveSection}}>Similar Activities</Grid>
                </Grid>
                <Grid item container xs={12} justify='center' alignItems='center' style={{height:'70%',}}>
                    <Grid item xs={8} md={6} lg={4} >
                        <Button disabled={true} disableRipple = {true} disableFocusRipple={true} style={{...styles.button}}>
                            Sign Me Up
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        )
    };

    DetailPagePreviewComponent = () =>{
        return(
            <Grid item container >
                <Grid item container alignItems='center' justify='center' xs={12} className='ActivityPreviewInfoComponnet' style={{padding:'10px'}}>
                    <this.DetailsInfoComponent/>
                </Grid>
            </Grid>
        )
    };

    DetailsInfoComponent = () =>{
        const backgroundImage = (this.props.themeImage && this.props.themeImage.iconUrl)? this.props.themeImage.iconUrl : ''; 

        const styles={
            infoContainer:{
                height:'100%',
                backgroundImage:`url(${backgroundImage})`,
                backgroundPosition:'center',
                backgroundRepeat:'no-repeat',
                backgroundSize: 'cover',
            },
            buttonscontainer:{
                height:'25%'
            },
        }
        
        return( 
            
            <Grid item container className='previewStyles' style={{ height:'100%'}}>
                <Grid item container id='detailsInfoComponent_container' xs={12} style={{...styles.infoContainer}}>
                    <Grid item container className='ActivityPreviewInfoContainer' style={{height:'75%', }}>
                        <Grid item container xs={8} style={{height:'100%', }} alignItems='flex-start'>
                            <this.TitleComponent/>
                            <this.DateComponent/>
                            <this.LocationComponent/>
                            <this.TransportationComponent/>
                            {/* <this.DescriptionComponent/> */}
                        </Grid>
                        <Grid item  container id='detailsImage_Component' xs={4} style={{ height:'100%'}} alignItems='center' justify='center' >
                            <Grid item  style={{height:'70%', width:'90%'}}>
                                {
                                    (this.props.detailsImage)?
                                        <img className='ActivityPreviewDetailsImage' alt='icon' src={this.props.detailsImage? this.props.detailsImage : undefined}/>
                                        :
                                        undefined
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item container style={{...styles.buttonscontainer, }} alignItems='center'>
                        <this.DetailsPreviewButtonsComponent/>
                    </Grid>
                </Grid>
            </Grid>
        );
    };
    //#endregion

    
    //#region MODAL
    ModalComponent = () =>{
        const screenSize = (this.state.rootScreenSize && this.state.rootScreenSize.screenSize)? this.state.rootScreenSize.screenSize : 'xs';
        const modalWidth =  screenSize ==='xs'? '90%': screenSize ==='md'? '70%': screenSize ==='lg'? '45%': '35%';

        const styles={
            paperModal:{
                backgroundColor:'#1F1F1F',
                padding:'6px',
                height:'85%',
                position:'absolute', 
                top:'50%', 
                left:'50%',
                transform:'translate(-50%,-50%)',
                width: modalWidth, 
                       
            },
            button:{
                fontSize:this.state.baseSize? this.state.baseSize * 1.2+ 'em': '1em',
                borderRadius:'56px',
                width:'100%',
                backgroundColor:'#009cdb',
                color:'white',
                textTransform:'none',
                marginBottom:'20px'
            }
        }

        const fullsizeComponent = this.state.fullSizeComponent;

        let component = undefined;
        let title = undefined
        
        switch(fullsizeComponent){
            case 'thumbnail':
                title = <Grid item xs={12}  className='ActivityPreviewTitleFullSize ActivityPreviewTitleFullSize_AlignCenter'>Thumbnail Preview</Grid>;
                component = 
                <Grid item container justify='center' alignContent='center' style={{ height:'100%'}}>
                {
                    this.ThumbnailInfoComponent()
                }
                </Grid>
                
                break;
            case 'detail':
                title = <Grid item xs={12} className='ActivityPreviewTitleFullSize ActivityPreviewTitleFullSize_AlignCenter'>Detail Page Preview</Grid>;
                component = 
                <Grid item container justify='center' alignContent='center' style={{ height:'100%'}}>    
                {
                    this.DetailsInfoComponent()
                }                    
                </Grid>
                break;
            default:
                component = undefined;
        }

        let componentWidth ={
            xs:10 , 
            md:10 ,
            lg:6
        };

        if(fullsizeComponent === 'detail'){
            componentWidth ={
                xs:10 , 
                md:10 ,
                lg:10
            }
        }


    return (
        <Modal
            open={this.state.fullSizeComponent? this.state.fullSizeComponent : false }
            onClose={() => this.setState({fullSizeComponent: undefined})}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <Paper className='modalPaperStyles' elevation={3} style={{...styles.paperModal}} color='secondary'>
                <Grid container  justify='center' style={{height:'100%', fontSize:'12px'}}>
                    <Grid item container {...componentWidth} justify='center' style={{height:'85%', overflow:'auto'}}>
                        <Grid item container alignContent='center' justify='center' style={{height:'25%'}} >
                        {
                            title
                        }
                        </Grid>
                        <Grid item container alignContent='center' justify='center' style={{ height:'75%'}}>
                        {
                            component
                        }
                        </Grid>
                    </Grid>
                    <Grid item container justify='center' alignItems='flex-end' style={{height:'15%', }}>
                        <Grid item xs={3}>
                            <Button  style={{...styles.button}} onClick={() => this.setState({fullSizeComponent: undefined})}>Close</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </Modal>
    )
    }
    //#endregion

    render(){
        return(
            <Grid container>
                <this.PreviewComponentsRow/>
                <this.ModalComponent/>
            </Grid>
        );
    }
};


function mapStateToProps(state){};

export default connect(mapStateToProps, {})(ActivityPreview);
